<template>
  <el-select
    :value="value"
    size="small"
    @change="handleChange"
    placeholder="请选择"
    style="width: 100%"
    filterable
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { productGroupList } from '@/service/getData'

export default {
  props: {
    value: '',
    wellid: Number,
  },
  data() {
    return {
      lists: [],
    }
  },
  created() {
    this.getList(this.value)
  },
  methods: {
    async getList(defaultValue = 0) {
      let res = await productGroupList({
        drill_well_id: this.wellid,
        size: 100,
      })
      if (res.status == 0) {
        this.lists = res.data.list
        if (defaultValue) {
          this.$emit('info', this.lists.filter((i) => i.id == defaultValue)[0])
        }
      }
    },
    handleChange(e) {
      this.$emit('input', e)
      this.$emit('info', this.lists.filter((i) => i.id == e)[0])
    },
  },
}
</script>